import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { NavigationService } from '../services/components/navigation.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private navigation: NavigationService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.status === 401) {
          this.navigation.goNotAuthorized();
          return;
        }

        if (error.error.error) return throwError(new Error(error.error.error))

        if (error.error) return throwError(new Error(error.error))

        if (error.error.message != undefined) {
          errorMessage = `Error: ${error.error.message}`;
        } else {
          errorMessage = `Error: ${error.message}`;
        }

        if (error.status === 404) {
          errorMessage = `Registro inexistente`;
        }
        if (errorMessage.indexOf("Http failure response for ") > 0) {
          errorMessage = "Verifique Conexión";
        }
        return throwError(new Error(errorMessage));
      }),
      // catchError((error: HttpErrorResponse) => {
      //   let errorMessage = '';
      //   debugger;
      //   if (error.status === 401) {
      //     this.navigation.goNotAuthorized();
      //     return;
      //   }
      //   if (error.error instanceof ErrorEvent) {
      //     errorMessage = `Error: ${error.error.message}`;
      //     console.log(error.error);
      //   } else {
      //     errorMessage = error.message;
      //     console.log(error.error);
      //     if (error.status === 404) {
      //       errorMessage = 'Registro inexistente';
      //     }
      //   }
      //   if (errorMessage.indexOf("Http failure response for ") > 0) {
      //     errorMessage = "Verifique Conexión";
      //   }
      //   return throwError(() => new Error(errorMessage));
      // }
      // ),
    );
  }
}
